export default {
    getDate(time,type) {
    var week = ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日",];
    if(time){
      time = Number(time);
       var date = new Date(time);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            D = D + " ";
        let h = date.getHours() < 10 ? '0' + date.getHours() + ":" : date.getHours() + ":";
        let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      if (type == 1) {
        return Y + M + D + h + m + ":" + s
      } else if (type == 2) {
        return Y + M + D
      } else if(type == 3){
        return Y + M + D + h + m
      } else if(type == 4){
        return h + m + ":" + s
      } else if(type == 5){
        return h + "00"
      } else if(type == 6){
        return h + m
      } else if (type==7){
        return M + D + h + m
      } else if(type==8){
        var index = date.getDay()-1;
        return week[index]
      } else if (type == 9) {
        return D
      }
    
    }else{
      return ""
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/utils/time.js